<div class="upload-file">
    <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (files)="filesSelected($event)"
    [ngClass]="{'d-none': isDisabled}">
        <input hidden type="file" #fileInput onclick="this.value = null" (change)="filesSelected($event.target.files);"
        accept="image/jpeg" [disabled]="isDisabled">
    </div>
    <ng-container> 
        <div [class.canvas-img]="!hasPriviewImage" #imageContainer>
            <div *ngIf="existingPhotoUrl"
                #existingImage
                [style.background-size]="backgroundSize"
                [appBackgroundUrl]="existingPhotoUrl" style="height: 260px !important; margin-top: 30px !important">
                <button type="button"class="btn btn-danger btn-delete" *ngIf="showRemove" (click)="removeImages()">
                    <i class="icon-close"></i> Remove image
                </button>
            </div>
        </div>
    </ng-container>
</div>
